import { Box, Text } from '@chakra-ui/react';
import EmailInput from 'components/Input/EmailInput';
import AuthButton from 'components/singIn/AuthButton';
import BackButton from 'components/singIn/BackButton';
import SecondState from 'components/singIn/SecondState';
import Subtitle from 'components/singIn/Subtitle';
import TextWithLink from 'components/singIn/TextWithLink';
import Title from 'components/singIn/Title';
import DefaultAuth from 'layouts/auth/Default';
import { useState } from 'react';

const Second = () => (
    <SecondState
        email="amanda.taylor1111111@gmail.com"
        title="Check your email"
        subtitle={
            <>
                We've sent an email to
                <Text as="span" color="gray.900">
                    amanda.taylor@gmail.com
                </Text>
                . Follow its instructions to finish your registration. If you dont see the email after a minute, please
                check your spam folder.
            </>
        }
        back={<BackButton href="/auth/sign-up">Back to Sign Up</BackButton>}
    />
);

function SignUp() {
    const [value, setValue] = useState(true);

    return (
        <DefaultAuth>
            {value ? (
                <Box width="420px" maxWidth="100%">
                    <Title>Sign Up</Title>
                    <Subtitle>Enter your email to continue the registration</Subtitle>
                    <EmailInput />
                    <TextWithLink
                        color="gray.900"
                        fontSize="sm"
                        text="By pressing Continue, you agree to"
                        linkText="Lead Pulse Terms of Use"
                        href="#"
                        sx={{ mb: '16px' }}
                    />
                    <AuthButton onClick={() => setValue(false)}>Continue</AuthButton>
                    <TextWithLink text="Already have an account?" linkText="Sign In" href="/auth/sign-in" />
                </Box>
            ) : (
                <Second />
            )}
        </DefaultAuth>
    );
}

export default SignUp;
